import Vue from "vue";
const envType = process.env.VUE_APP_CURRENTMODE
let baseURL = {}
if (process.env.NODE_ENV === 'development' || envType === 'stage') {
    // 开发环境 || 测试
    // baseURL.AHEAD = 'http://test-biz.meetnovel.com'

    baseURL.AHEAD = 'https://test-biz.zhangwenpindu.cn'
    // baseURL.AHEAD = 'https://test-www.zhangwenpindu.cn'
    // baseURL.AHEAD = 'http://192.168.0.69:9600'


    baseURL.AUTHOR = 'http://test-biz.meetnovel.com/author'
    baseURL.NOTICE = 'http://test-biz.meetnovel.com/notice'
    baseURL.CONSUME = 'http://test-biz.meetnovel.com/consume'
    baseURL.CDNCONSUME = 'http://test.cdn.meetnovel.com/consume'
    baseURL.SEARCH = 'http://test-search.meetnovel.com/search'
    baseURL.IMG = "http://test-img.meetnovel.com"
} else if (envType === 'prod') {
    // 生产
    baseURL.AHEAD = 'https://biz.zhangwenpindu.cn'

    baseURL.AUTHOR = 'https://biz.meetnovel.com/author'
    baseURL.NOTICE = 'https://biz.meetnovel.com/notice'
    baseURL.CONSUME = 'https://biz.meetnovel.com/consume'
    baseURL.CDNCONSUME = 'https://cdn.meetnovel.com/consume'
    baseURL.SEARCH = 'https://search.meetnovel.com/search'
    baseURL.IMG = "https://img.meetnovel.com"
    Vue.prototype.isShowA = false;
} else {
}

export default baseURL
